import MaintenanceEditor from '@/components/maintenace/MaintenanceEditor.vue';
import Loader from '@/components/loader/Loader.vue';

export default {
  name: "scheduledMaintenanceFormEditDlg",
  components: {
    Loader,
    MaintenanceEditor,
  },
  data() {
    return {
      dialog: false,
      template: null,
      saving: false,
      loading: true,
      isDisabledSave: true,
      isSurveyModified: false,
      isDisabled: false
    }
  },
  computed: {
    maintenanceForm() {
      return this.$store.state.maintenanceModule.maintenanceForm;
    }
  },
  methods: {
    async open(form, status: string) {
      this.isDisabled = status === 'view';
      await this.$store.dispatch("getMaintenanceForm", form?.formId);
      this.template = this.maintenanceForm ?? form;
      this.dialog = true;
      this.loading = false;
    },
    modify() {
      this.isDisabledSave = true;
    },
    close() {
      this.dialog = false;
      this.isDisabled = false;
    },
    async submit() {
      this.saving = true;

      try {
        await this.$store.dispatch("saveMaintenanceForm", {
          id: this.maintenanceForm.id,
          template: this.template
        });

        await this.$store.dispatch('getMaintenanceFormsByMaintenanceRequestId', this.$route.params.id);

        this.$toast.open({
          message: this.$t("MaintenanceTemplates.MaintenanceFormUpdated"),
          type: "success"
        });
      } catch (err) {
        this.$toast.open({
          message: err.message,
          type: "error"
        });
      } finally {
        this.saving = false;
        this.isDisabledSave = true;
      }
    }
  },
  watch: {
    'maintenanceForm.template'(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        setTimeout(() => {
          this.isDisabledSave = false
        }, 3000)
      }
    },
  }
}